import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import Button from 'components/Buttons/Button';

interface StyledProps {
  hasList?: boolean;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100%;
`;

export const Content = styled.div<StyledProps>`
  display: flex;
  flex-direction: column;
  margin-bottom: ${({ hasList }) => (hasList ? 116 : 0)}px;

  @media ${({ theme }) => theme.device.desktop} {
    margin-bottom: 0;
  }
`;

export const AppBarCenter = styled.div`
  text-align: center;
`;

export const List = styled.ol`
  display: flex;

  @media ${({ theme }) => theme.device.mobile} {
    flex-direction: column;
    align-items: center;
  }

  @media ${({ theme }) => theme.device.desktop} {
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
  }
`;

export const ResultsFound = styled.span`
  display: inline-flex;
  align-items: center;
  background-color: rgba(${ColorPalette.RGB.BrightGray}, 0.5);
  color: ${ColorPalette.HEX.DimGray};
  height: 40px;
  padding: 0 24px;
  line-height: 1.4px;
  margin-bottom: 20px;

  @media ${({ theme }) => theme.device.mobile} {
    margin: 0 16px 20px 16px;
  }
`;

export const BoxContainer = styled.div`
  display: flex;
  height: 80px;
  align-items: center;
  padding: 0 24px;
  width: 100%;
  border: 1px ${({ theme }) => theme.rule.ruleList.lightGrey};
  border-style: solid none;
  background-color: ${({ theme }) => theme.rule.ruleList.white};

  @media ${({ theme }) => theme.device.desktop} {
    margin-bottom: 16px;
    border: none;
  }
`;

export const ButtonGhost: any = styled.button`
  display: flex;
  background-color: ${({ theme }) => theme.rule.ruleList.white};
  background: none;
  border: none;
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.rule.ruleList.primary};
  cursor: pointer;
`;

ButtonGhost.Icon = styled.img`
  margin-right: 8px;
`;

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  @media ${({ theme }) => theme.device.desktop} {
    position: sticky;
    bottom: 0;
    margin-top: auto;
  }

  @media ${({ theme }) => theme.device.mobile} {
    height: 70px;
    background-color: ${({ theme }) => theme.rule.ruleList.white};
    left: 0;
    bottom: 0;
    right: 0;
    position: fixed;
  }
`;

export const StyledButton = styled(Button)`
  margin: 0px 16px 32px 16px;
  height: auto;
  min-height: 55px;
  font-size: 16px;
  line-height: initial;
  padding: 14px;

  @media ${({ theme }) => theme.device.desktop} {
    margin: 0;
  }
`;

export const SubTitle = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.usersList.dataColor};
  text-align: center;
  font-weight: normal;
`;
